// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__z1Tbj","fade":"Toast_fade__Zx5TZ"};